import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer'
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer'
import { IFileTransfertConfig } from './fileTransfert/IFileTransfertConfig'


export class IrisrawModFileTransfer extends IrisModContainer<IrisConfigContainer<IFileTransfertConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModFileTransfer.createIrisFileTransfertConfig)        
    }

    static createIrisrawModFileTransfer(datas:IIrisModContainerConstParam) {        
        return new IrisrawModFileTransfer(datas)
    }

    static createIrisFileTransfertConfig(data:IIrisConfigContainerConstParam) {        
        return new IrisConfigContainer<IFileTransfertConfig>(data)
    }

}
